// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "211a353e6fe160df","396": "868ab3fb5d7cd899","460": "792066f7d62618cc","498": "87d8aff25fab2f12","917": "d8239b1b6506438c","985": "1982aacade7b9f20",}[chunkId] + ".chunk.js"
}